export const logServicesRoutes = (apiBase) => ({
  logServicesCatalogos: `${apiBase}/logServices/catalogos`,
  logServicesListar: `${apiBase}/logServices/listar`,
  logServicesInactivar: `${apiBase}/logServices/inactivar`,
});
